// @ts-ignore
import { ApiClient } from "../../lib/ApiClient";
import { useGenericSWR } from "../../lib/useGenericSWR";
import { SwrOptions } from "../../lib/useGenericSWR.interfaces";
// @ts-ignore
import { ensureLuxonDate } from '../../lib/Formatters';

const billingCycleUrl = 'api/v1/AggBillingCycleReading';
const dailyUrl = 'api/v1/HistoricalComparison/day';
const dailyWeatherUrl = 'api/v1/HistoricalComparison/weather/day';

const apiClient = new ApiClient();

const useHistoricalComparison = (chartType: string, accountId: number | null | undefined, selectedMeter: string, uom: string, startDate: unknown, endDate: unknown, yearOne: number, yearTwo: number, swrOptions: SwrOptions) => {
    const params = new URLSearchParams();
    params.append('accountId', accountId?.toString() ?? "");
    params.append('selectedMeter', selectedMeter?.toString());
    params.append('uom', uom);
    params.append('startDate', ensureLuxonDate(startDate)?.toUTC().toISO());
    params.append('endDate', ensureLuxonDate(endDate)?.toUTC().toISO());
    params.append('yearOne', yearOne?.toString() ?? null);
    params.append('yearTwo', yearTwo?.toString() ?? null);

    let url = "";
    if (accountId !== null && selectedMeter !== null && startDate !== undefined && endDate !== undefined && yearOne !== null && yearTwo !== null) {
        if (chartType === "month") {
            url = billingCycleUrl + "/AggBillingCycleReadingsHistoricalAccount?" + params.toString();
        }
        else if (chartType === "day") {
            url = dailyUrl + "?" + params.toString();         
        }
    }

    return useGenericSWR(url, apiClient, { ...swrOptions });

};

const useHistoricalComparisonDailyWeather = (startDate: unknown, endDate: unknown, yearOne: number, yearTwo: number, geoCoordinates: any, swrOptions: SwrOptions = {}) => {
    const params = new URLSearchParams();
    params.append('startDate', ensureLuxonDate(startDate)?.toUTC().toISO());
    params.append('endDate', ensureLuxonDate(endDate)?.toUTC().toISO());
    params.append('yearOne', yearOne?.toString());
    params.append('yearTwo', yearTwo?.toString());
    params.append('geoCoordinatesJson', JSON.stringify(geoCoordinates));

    let url = "";
    if (startDate && endDate && yearOne && yearTwo && geoCoordinates) {
        url = dailyWeatherUrl + "?" + params.toString();
    }

    return useGenericSWR(url, apiClient, swrOptions);
};

export {
    useHistoricalComparison,
    useHistoricalComparisonDailyWeather
};